module.exports = __webpack_public_path__ + "img/2021-2.f29aa907.jpg";